import { toRefs, reactive, ref } from 'vue'

export function getFormFields() {
  return {
    promptContent: '',
    promptName: '',
    status: 1
  }
}

export const useConfig = (configList) => {
  const helperForm = ref(getFormFields())
  const configFormModel = reactive({
    showFormModal: false,
    formType: 'add',
    editIndex: -1
  })

  const onAdd = () => {
    configFormModel.formType = 'add'
    configFormModel.showFormModal = true
  }

  function onEdit(i, index) {
    configFormModel.editIndex = index
    configFormModel.formType = 'edit'
    configFormModel.showFormModal = true
    helperForm.value = { ...i }
  }

  function onRemove(index) {
    configList.value = configList.value.filter((item, i) => i !== index)
  }

  function onModalConfirm() {
    if (configFormModel.formType === 'add') {
      configList.value.push({ ...helperForm.value })
    }

    if (configFormModel.formType === 'edit') {
      configList.value.splice(configFormModel.editIndex, 1, { ...helperForm.value })
    }
    onClose()
  }

  function onClose() {
    configFormModel.showFormModal = false
    helperForm.value = getFormFields()
    configFormModel.editIndex = -1
  }

  return {
    ...toRefs(configFormModel),
    helperForm,
    onAdd,
    onEdit,
    onClose,
    onRemove,
    onModalConfirm
  }
}

/**
 * Hook for parsing instructions
 * @param {Object} options
 * @param {Function} options.onConfirm - Callback when instruction is confirmed
 * @returns {Object}
 */
export const useParseInstruction = (options = {}) => {
  const { onConfirm, onRemove } = options
  const addAnalysisOrderModal = ref(false)
  const analysisOrderFormRef = ref(null)
  const analysisOrderForm = reactive({
    name: '',
    desc: ''
  })

  /**
   * Open the modal
   */
  const onAddAnalysisOrder = () => {
    addAnalysisOrderModal.value = true
    analysisOrderForm.name = ''
    analysisOrderForm.desc = ''
  }

  /**
   * Close the modal
   */
  const onAddAnalysisOrderModalClose = () => {
    addAnalysisOrderModal.value = false
  }

  const onRemoveAnalysisRemove = (index) => {
    if (onRemove) {
      onRemove(index)
    }
  }

  /**
   * Confirm and save the instruction
   */
  const onAddAnalysisOrderConfirm = () => {
    analysisOrderFormRef.value.validate((valid) => {
      if (valid) {
        // Parse instruction logic (as per requirements, though simple here)
        const structuredData = {
          title: analysisOrderForm.name,
          desc: analysisOrderForm.desc
        }

        if (onConfirm) {
          onConfirm(structuredData)
        }
        onAddAnalysisOrderModalClose()
      }
    })
  }

  return {
    addAnalysisOrderModal,
    analysisOrderForm,
    analysisOrderFormRef,
    onAddAnalysisOrder,
    onAddAnalysisOrderModalClose,
    onAddAnalysisOrderConfirm,
    onRemoveAnalysisRemove

  }
}
